import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_above_facility_meeting_measures_listed_above_prevent'

export const dataPointDefinition = {
  retracedId: 'none_above_facility_meeting_measures_listed_above_prevent',
  name: 'None of the above - the facility is meeting all measures listed above to prevent the spread of contagious diseases',
  description:
    'Select "X" if the facility HAS all the measures to prevent the spread of contagious diseases described above.',
  meta: {
    slcpMeta: {
      key: 'hs-fir-44x',
      number: 'HS-FIR-9-5',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-fir-44x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31150,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
